export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const CLEAR_USER_TOKEN = 'CLEAR_USER_TOKEN';